import { resolveImageSource } from "../../../../../utils/resolveImageSource";
import { maskEditTargetsResult } from "./maskEditTarget";

export { maskEditTargetsResult };

/**
 * A new brush mask painted on the result must be sent with that result.
 * A prompt with no new mask keeps the original upload.
 */
export async function resolveMaskEditSource({
  token,
  file = null,
  image_url = null,
  resultImageUrl = null,
  stageKey = "original",
  hasMask = false,
  filename = "mask-edit-input.png",
}) {
  if (!maskEditTargetsResult(hasMask, resultImageUrl, stageKey)) {
    return { file, image_url };
  }
  return resolveImageSource({
    sourceUrl: resultImageUrl,
    filename,
    token,
  });
}
